import React from 'react';
interface Props {
  fillColor?: string;
}
function SleepIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none">
      <g clipPath="url(#clip0_851_3366)">
        <path
          d="M5.75069 0.355469C5.33507 0.355469 5.00069 0.689844 5.00069 1.10547C5.00069 1.52109 5.33507 1.85547 5.75069 1.85547H7.59757L5.18507 4.61172C4.99132 4.83359 4.94444 5.14609 5.06632 5.41484C5.18819 5.68359 5.45694 5.85547 5.75069 5.85547H9.25069C9.66632 5.85547 10.0007 5.52109 10.0007 5.10547C10.0007 4.68984 9.66632 4.35547 9.25069 4.35547H7.40382L9.81632 1.59922C10.0101 1.37734 10.0569 1.06484 9.93507 0.796094C9.81319 0.527344 9.54444 0.355469 9.25069 0.355469H5.75069ZM9.75069 7.35547C9.33507 7.35547 9.00069 7.68984 9.00069 8.10547C9.00069 8.52109 9.33507 8.85547 9.75069 8.85547H11.7163L9.16007 12.1461C8.98507 12.3711 8.95382 12.6773 9.07882 12.9367C9.20382 13.1961 9.46632 13.3586 9.75382 13.3586H13.2538C13.6694 13.3586 14.0038 13.0242 14.0038 12.6086C14.0038 12.193 13.6694 11.8586 13.2538 11.8586H11.2882L13.8476 8.56797C14.0226 8.34297 14.0538 8.03672 13.9288 7.77734C13.8038 7.51797 13.5413 7.35547 13.2538 7.35547H9.75382H9.75069ZM0.750692 7.35547C0.335067 7.35547 0.000691773 7.68984 0.000691773 8.10547C0.000691773 8.52109 0.335067 8.85547 0.750692 8.85547H4.76944L0.144442 15.1617C-0.0211832 15.3898 -0.0461832 15.693 0.0788168 15.943C0.203817 16.193 0.469442 16.3555 0.750692 16.3555H6.25069C6.66632 16.3555 7.00069 16.0211 7.00069 15.6055C7.00069 15.1898 6.66632 14.8555 6.25069 14.8555H2.23194L6.85694 8.54922C7.02257 8.32109 7.04757 8.01797 6.92257 7.76797C6.79757 7.51797 6.53194 7.35547 6.25069 7.35547H0.750692Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3366">
          <rect
            width="14"
            height="16"
            fill="white"
            transform="translate(0 0.355469)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SleepIcon;
